import React from 'react';
import './home.css';
import {
  FaUtensils,
  FaHeartbeat,
  FaTshirt,
  FaIndustry,
  FaBolt,
} from "react-icons/fa";

const industries = [
  {
    icon: <FaUtensils />,
    title: "Food & Beverages",
  },
  {
    icon: <FaHeartbeat />,
    title: "Medical",
  },
  {
    icon: <FaTshirt />,
    title: "Garments",
  },
  {
    icon: <FaIndustry />,
    title: "Plastic Industry",
  },
  {
    icon: <FaBolt />,
    title: "Electrical & Electronic Assemblies",
  },
];

export default function FocusIndustries() {
  return (
   <section className="industries-section">
  <h2>Industries We Serve</h2>

  <p className="section-description">
    Delivering innovative conveyor and material handling solutions
    across diverse industries to improve productivity and operational efficiency.
  </p>

  <div className="industries-grid">

    <div className="industry-card">
      <div className="industry-icon"><FaUtensils /></div>
      <h3>Food & Beverages</h3>
      <p>Efficient conveyor solutions for food processing, packaging, and distribution.</p>
    </div>

    <div className="industry-card">
      <div className="industry-icon"><FaHeartbeat /></div>
      <h3>Medical</h3>
      <p>Reliable systems for pharmaceutical and medical manufacturing environments.</p>
    </div>

    <div className="industry-card">
      <div className="industry-icon"><FaTshirt /></div>
      <h3>Garments</h3>
      <p>Optimized material handling for textile and garment production workflows.</p>
    </div>

    <div className="industry-card">
      <div className="industry-icon"><FaIndustry /></div>
      <h3>Plastic Industry</h3>
      <p>Durable conveyor systems for molding, assembly, and packaging operations.</p>
    </div>

    <div className="industry-card">
      <div className="industry-icon"><FaBolt /></div>
      <h3>Electrical & Electronic Assemblies</h3>
      <p>Precision conveyor solutions for electronics assembly and testing lines.</p>
    </div>

  </div>
</section>
  );
}